module.exports = __webpack_public_path__ + "67d6fef9d9fc482d22252bea0fbc932d.png";